import axios from 'axios';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

interface Obj {
  url: string;
  data?: any;
headers?: any;
  tag?:string;
  page?:number;
  count?:number;
  viewMore?:boolean;
  all?:boolean
}

export const getApi = (obj: Obj) => {
  return axios.get( API_BASE_URL + obj.url, {
    params: {
      ...obj.data,
    },
  })
}

export const postApi = (obj: Obj) => {
  return axios.post(
    API_BASE_URL +
    obj.url,
    {
      ...obj.data,
    },
  );
}

export const storyBlockApi = (obj:Obj) => {
  const version = 'published'
  const startWith = obj.url
  const tag = obj.tag
  const page = obj.page || 1
  const count = startWith === 'trending-articles' ? obj.count || 3 : 6;
  const viewMore = obj.viewMore
  let url = `/stories?version=${version}&token=${process.env.REACT_APP_STORYBLOK_API_KEY}&resolve_relations=tag_list`;
  if(!viewMore) {
    url += `&starts_with=${startWith}&per_page=${obj.all?100:count}&page=${page}`
  }else{
    url +=  url += `&starts_with=${startWith}&per_page=${obj.all?100:4 * page}&page=${1}`
  }
  if(tag && tag !== 'All'){
    url+=`&with_tag=${tag}`
  }
  return axios.get(
    process.env.REACT_APP_STORYBLOK_BASE_URL + url
  );
}